/**
 * The API's work-email rules, shared so the form can say "use your work email" before submitting.
 * The API applies the same module and is the authority.
 */
export {
	companyFromEmail as companyHint,
	isPersonalEmail
} from "solution-advisor-application-services/workEmail";

const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** A quick shape check before asking the API (which validates properly). */
export const looksLikeEmail = (value: string) => EMAIL_SHAPE.test(value);
